export function createPulseLogger(debug) {
    return {
        info: (message, ...args) => {
            if (debug) {
                console.info(`[Pulse] ${message}`, args);
            }
        },
        warn: (message, ...args) => {
            if (debug) {
                console.warn(`[Pulse] ${message}`, args);
            }
        },
        error: (message, ...args) => {
            if (debug) {
                console.error(`[Pulse] ${message}`, args);
            }
        },
    };
}
//# sourceMappingURL=pulse-logger.js.map